import { render } from "./MfittBookingSalesEndError.vue?vue&type=template&id=621644bf"
import script from "./MfittBookingSalesEndError.vue?vue&type=script&lang=js"
export * from "./MfittBookingSalesEndError.vue?vue&type=script&lang=js"
script.render = render

export default script